export default __webpack_public_path__ + "static/media/positioning positioning 1 - faces - originals - dolamubadejo bdic 2.f733a85f.png";